import React from "react";
import { connect } from "react-redux";
import Select from "react-dropdown-select";
import "../Forms/css/register.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class EditBrandsNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {   
      name: '',
     
      image: '',
    
      submissionStatus: null,
      id: null,
      imageFile: null,
     
    };
  }
  
  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchData = async (id) => {
    console.log("Fetch data called with id:", id);
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/brandsnew/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response?.data;
      console.log("Fetch data response:", userData);
      if (userData) {
        this.setState({
          name: userData?.name || '',
        
          image: userData?.image || '',
         
        });
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFileChange = (e) => {
    const { name, files } = e.target;
    this.setState({ [`${name}File`]: files[0] });
  };

  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field]
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    const formData = new FormData();
    
    // Append non-file fields
    Object.keys(this.state).forEach(key => {
      if (key.endsWith('File')) {
        if (this.state[key]) {
          formData.append(key.replace('File', ''), this.state[key]);
        }
      } else {
        if (this.state[key] !== '') {
          formData.append(key, this.state[key]);
        }
      }
    });
  
    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.put(`https://brand.aasmo.in/api/admin/brandsnew/${id}`, formData, config);
      console.log('Response:', response);
      if (response && response.status === 200) {  // Changed to 200 for successful update
        this.setState({ submissionStatus: 'success' });
        console.log('Form submitted successfully');
        setTimeout(() => {
          this.props.history.push('/list-brandsNew');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };
  

  render() {
    const { submissionStatus, image, name, imageFile, identityImageFile } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Brands</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label>Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={this.state.name}
                      onChange={this.handleChange}
                      placeholder="Category Name"
                    />
                  </div>
              
               
                  <div className="form-group">
                    <label>Image</label>
                    <input
                      type="file"
                      className="form-control"
                      name="image"
                      onChange={this.handleFileChange}
                    />
                  <div className="col-md-6">
                  {(imageFile || image) && (
                      <img
                        src={imageFile ? URL.createObjectURL(imageFile) : image}
                        alt="image"
                        className="img-thumbnail mt-2"
                      />
                    )}
                  </div>
                  </div>
                  {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}
              <button
                className="btn btn-primary"
                onClick={(e) => {
                  this.setState({ submit: true });
                  this.handleSubmit(e);
                }}
              >
                Submit
              </button>
                </div>
              
              </div>
            </div>
         
         
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default withRouter(EditBrandsNew);
